export class SetConnectedDto {
    constructor(public ConnectionId: number, public Connected: boolean) {
    }
}